var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        size: "lg",
        id: "createTabModal",
        centered: "",
        "hide-footer": "",
        title: _vm.$t("pos_contacts_modal_title"),
      },
      on: { hidden: _vm.clear },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "create-tab-form" },
        [
          _c("Taggregator", {
            ref: "addGuestsTags",
            attrs: {
              label: _vm.$t("pos_contacts_description_label"),
              items: _vm.guests,
              selections: _vm.selectedGuestIds,
              maximum: 1,
              name: "guests",
              onAdd: _vm.setupTab,
              quickAddDescription: "Please provide valid first and last names",
              quickAddCallback: _vm.createGuest,
            },
            on: {
              "update:selections": function ($event) {
                _vm.selectedGuestIds = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }